import './MobileSmallHeader.css'

interface IMobileSmallHeaderProps {
    logo: string
    downloadLink: string
    downloadIcon: string
}

export default function MobileSmallHeader(props: IMobileSmallHeaderProps) {
    return <div className="Mobile_small_header">
        <img src={props.logo} className="Mobile_small_header__logo"/>
        <img
            className="Mobile_small_header__download"
            src={props.downloadIcon}
            onClick={(e) => window.open(props.downloadLink, "_blank")}
        />
    </div>
}